import { Dayjs } from 'dayjs'

export interface EventsFormValues {
  id: string
  title: string
  place: string
  manager: string
  site: string
  date: Dayjs | null
}

export const INITIAL_EVENTS_VALUES: EventsFormValues = {
  id: '',
  title: '',
  place: '',
  manager: '',
  site: 'Sede Principal',
  date: null,
}
